import { Grid } from '@material-ui/core'
import React, { useContext, useEffect, useState } from 'react'
import CustomAddPage from '../../../components/CustomComponents/CustomAddPage'
import CustomHeading from '../../../components/CustomHeading'
import CustomInput from '../../../components/CustomInput'
import CustomLabel from '../../../components/CustomLabel'
import CustomAddForm from '../../../components/version-4/MasterForms/CustomAddForm'
import { ConfigurationContext } from '../../../context api/Configuration/ConfigurationContext'
import { useUploadHeader } from '../../../hooks/CompanyConfiguration/useUploadHeader'

export default function AddUploadHeader({ uploadHeader }) {
  const [uploadHeaderData, setUploadHeaderData] = useState({
    name: 'Sales',
  })
  const { addUploadHeader, loading, updateUploadHeader, getAllUploadHeader } = useUploadHeader()
  const { uploadHeaders } = useContext(ConfigurationContext)

  useEffect(() => {
    getAllUploadHeader()
  }, [])

  const tempHeaders = uploadHeaders && uploadHeaders.map((item) => item.name)
  console.log('temp Headers  : ', tempHeaders)
  let tempOptions = ['Category', 'SubCategory', 'Product', 'Sales']

  // const filter = tempHeaders.every((val) => tempOptions.includes(val))
  // console.log('TEMP OIPTIONS : ', filter)
  let categoryUpload = { categoryCode: '', name: '', description: '', image: '' }

  const [data, setData] = useState({
    Sales: { saleType: '', storeCode: '', quantity: '', invoiceDate: '', sku: '', invoiceNumber: '', orderNumber: '', amount: '' },
    Category: categoryUpload,
    SubCategory: { ...categoryUpload, subcategoryCode: '' },
    Product: {
      categoryCode: '',
      subcategoryCode: '',
      name: '',
      color: '',
      sku: '',
      dealerPrice: '',
      primaryImage: '',
      secondaryImage: '',
      description: '',
      mustOrder: '',
      primaryVariant: '',
      active: '',
    },
  })

  useEffect(() => {
    if (uploadHeader) {
      setUploadHeaderData({ ...uploadHeader })
      setData({ ...data, [uploadHeader.name]: uploadHeader.headers })
    }
  }, [uploadHeader])

  const inputFields = [{ label: 'Choose Module', value: uploadHeaderData.name, name: 'name', options: tempOptions }]

  const handleForm = () => {
    if (uploadHeader) {
      updateUploadHeader({ ...uploadHeaderData, headers: data[uploadHeaderData.name], uploadHeaderId: uploadHeader._id })
    } else {
      addUploadHeader({ ...uploadHeaderData, headers: data[uploadHeaderData.name] })
    }
  }

  return (
    <CustomAddPage heading="Sales Upload Header" redirect="ALL_UPLOAD_HEADERS" currentData={uploadHeader} loading={loading} handleClick={handleForm}>
      {/* <CustomAddForm state={uploadHeaderData} setState={setUploadHeaderData} data={inputFields} /> */}
      {/* <br /> */}
      {/* <CustomHeading heading="Compare" /> */}

      {data[uploadHeaderData.name] &&
        Object.keys(data[uploadHeaderData.name]).map((key, index) => {
          return (
            <Grid container alignItems="flex-end">
              <Grid item lg={1} />
              <Grid item lg={4}>
                <CustomLabel label={key} />
              </Grid>
              <Grid item lg={4}>
                <CustomInput
                  value={data[uploadHeaderData.name][key]}
                  onChange={(e) => {
                    let obj = data
                    obj[uploadHeaderData.name][key] = e.target.value
                    setData({ ...obj })
                  }}
                />
              </Grid>
            </Grid>
          )
        })}
    </CustomAddPage>
  )
}
